export default __webpack_public_path__ + "5668ced190f1a30c8d77e25d10904f8c.svg";